import { Injectable } from '@angular/core';
import { Config } from '../config';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NavigationNotificationBadgeData } from '../model/user';
import { ReportsService } from './reports.service';

interface DateFilter {
  startDate?: string;
}

@Injectable({ providedIn: 'root' })
export class MentorLoginReportService {
  /**
   * The start and end date for the date filter.
   */
  selectedDate: DateFilter = {
    startDate: '',
  };

  /**
   * Creates a new instance of login-logout-report service
   */
  constructor(private http: HttpClient, private rptService: ReportsService) {}

  /**
   * Changes the start and end date for the date filter.
   */
  setSelectedDate(date: any) {
    this.selectedDate.startDate = date;
  }

  /**
   * Performs the request for the trip data from the API.
   */
  getTrips(headers = null): Observable<any> {
    return this.http.get(`${Config.apiRoot.uri}reports/driver/trips`, {
      params: {
        startTime: `${this.selectedDate.startDate}`,
      },
      headers,
    });
  }

  /**
   * Performs the request for the trip data from the API.
   */
  getMeta(headers = null): Observable<any> {
    return this.http.get(`${Config.apiRoot.uri}reports/driver/trips/meta`, {
      params: {},
      headers,
    });
  }

  /**
   * Http request to get drivers that have not logged in today
   */
  public fecthOutstanding(): Observable<any> {
    return this.http.get(`${Config.apiRoot.uri}reports/driver/trips/total`);
  }

  /**
   * Return object to be used by the notification badge
   */
  getNotificationCount(): Observable<NavigationNotificationBadgeData> {
    return this.fecthOutstanding().pipe(
      map((response) => {
        this.rptService.loginLogoutNotificationsCount = response.total;
        return { total: this.rptService.loginLogoutNotificationsCount };
      })
    );
  }
}
